var map = {
	"./ARROW/preview_1.svg": "./src/images/cursors/ARROW/preview_1.svg",
	"./BLURRED/preview_1.svg": "./src/images/cursors/BLURRED/preview_1.svg",
	"./BLURRED/project_hover_1.svg": "./src/images/cursors/BLURRED/project_hover_1.svg",
	"./CIRCLE/preview_1.svg": "./src/images/cursors/CIRCLE/preview_1.svg",
	"./DEFAULT/preview_1.svg": "./src/images/cursors/DEFAULT/preview_1.svg",
	"./EMOJI/preview_1.svg": "./src/images/cursors/EMOJI/preview_1.svg",
	"./FIGMA/preview_1.svg": "./src/images/cursors/FIGMA/preview_1.svg",
	"./LABELED/preview_1.svg": "./src/images/cursors/LABELED/preview_1.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/cursors sync recursive ^\\.\\/.*_1\\.svg$";